export default __webpack_public_path__ + "static/media/donna-fraser-marked.b1991925.png";